import React from 'react';

const isChunkLoadError = (error) => {
  const msg = error?.message || '';
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    error?.name === 'ChunkLoadError'
  );
};

export class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, chunkError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, chunkError: isChunkLoadError(error) };
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    if (this.state.chunkError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '300px', padding: '40px', textAlign: 'center',
        }}>
          <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8, color: '#111' }}>
            A new version is available
          </div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 24, maxWidth: 360 }}>
            Refresh the page to load the latest version of the app.
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', background: '#232562', color: 'white',
              border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600,
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '300px', padding: '40px', textAlign: 'center',
      }}>
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8, color: '#111' }}>
          Something went wrong
        </div>
        <div style={{ fontSize: 13, color: '#666', marginBottom: 24, maxWidth: 360 }}>
          This section failed to load. Try refreshing the page.
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 24px', background: '#232562', color: 'white',
            border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600,
          }}
        >
          Refresh Page
        </button>
      </div>
    );
  }
}
